"use client";

import React from "react";
import Image from "next/image";

function Support({ heading = "Compliance Support Designed for International Founders" }: { heading?: string } = {}) {
  return (
    <section className="py-20 px-28 max-sm:py-10 max-sm:px-4 sm:max-[1439px]:py-16 sm:max-[1439px]:px-10">
      <div className="bg-[#1644EB] relative flex max-sm:flex-col sm:max-[1023px]:flex-col max-w-[1200px] w-full h-[487px] rounded-[20px] mx-auto overflow-hidden max-sm:h-auto sm:max-[1023px]:h-auto">
        <Image
          src="/corporate-secretary/ellipse.svg"
          height={889}
          width={889}
          alt="Bg Ellipse"
          className="absolute -right-64 max-sm:top-auto max-sm:bottom-4 max-sm:-right-20 -top-20 z-0 "
        />
        <div className="flex  items-center h-full justify-center w-[780px] max-sm:w-full max-sm:h-auto max-sm:items-start max-sm:justify-start max-sm:px-6 max-sm:pt-10 max-sm:pb-6 sm:max-[1023px]:w-full sm:max-[1023px]:h-auto sm:max-[1023px]:items-start sm:max-[1023px]:justify-start sm:max-[1023px]:px-6 sm:max-[1023px]:pt-10 sm:max-[1023px]:pb-6 min-[1024px]:max-[1439px]:w-[60%]">
          <div className="w-[715px] h-full flex flex-col gap-7 items-center justify-center max-sm:w-full max-sm:h-auto max-sm:items-start max-sm:justify-start max-sm:gap-5 sm:max-[1023px]:w-full sm:max-[1023px]:h-auto sm:max-[1023px]:items-start sm:max-[1023px]:justify-start sm:max-[1023px]:gap-5 min-[1024px]:max-[1439px]:w-full min-[1024px]:max-[1439px]:max-w-[560px]">
            <h2 className="font-inter font-bold text-[56px] leading-[110%] tracking-[-2px] text-white min-[1024px]:max-[1439px]:text-[44px] min-[1024px]:max-[1439px]:tracking-[-1px] sm:max-[1023px]:text-[32px] sm:max-[1023px]:leading-[120%] sm:max-[1023px]:tracking-[-0.5px] max-sm:text-[28px] max-sm:leading-[120%] max-sm:tracking-[-0.5px]">
              {heading}
            </h2>
            <p className="text-white text-[18px] leading-[24px] font-inter font-medium w-[530px] self-start max-sm:w-full sm:max-[1023px]:w-full min-[1024px]:max-[1439px]:text-[16px] min-[1024px]:max-[1439px]:w-full">
              Whether you&apos;re setting up a new Hong Kong company or
              transitioning from another provider, MuteTaxes helps keep your
              structure compliant while supporting your offshore tax position.
            </p>
            <div className="self-start bg-transparent h-[48px] flex items-center w-fit gap-2 border border-[#6fa6ff] text-[#6fa6ff] px-5 py-2.5 rounded-lg text-sm font-normal hover:bg-white/5 hover:border-transparent transition max-sm:h-auto max-sm:py-3 max-sm:px-6">
              Get Corporate Secretarial Help
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.7965 9.99932L7.08398 6.28682L8.14448 5.22632L12.9175 9.99932L8.14448 14.7723L7.08398 13.7118L10.7965 9.99932Z"
                    fill="#6fa6ff"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div className="w-[670px] -right-4 top-12 absolute max-sm:relative max-sm:w-full max-sm:h-[300px] sm:max-[1023px]:w-full sm:max-[1023px]:h-[360px] min-[1024px]:max-[1439px]:w-[40%]">
          <Image
            src="/corporate-secretary/support.png"
            height={476}
            width={714}
            alt="Support"
            className="object-cover max-sm:object-contain absolute h-[476px] w-[714px] rounded-2xl right-4 -top-[37px] min-[1024px]:max-[1439px]:h-[460px] min-[1024px]:max-[1439px]:w-[380px] min-[1024px]:max-[1439px]:right-2 min-[1024px]:max-[1439px]:-top-[20px] sm:max-[1023px]:h-[380px] sm:max-[1023px]:w-[320px] sm:max-[1023px]:right-1/2 sm:max-[1023px]:translate-x-1/2 sm:max-[1023px]:top-0 max-sm:inset-0 max-sm:h-full max-sm:w-full max-sm:bottom-0 max-sm:right-0 max-sm:translate-x-0 max-sm:rounded-none max-sm:rounded-b-[20px] "
          />
        </div>
      </div>
    </section>
  );
}

export default Support;
